/********************* Libaraies ***********************/
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
/********************* Components Core ***********************/
import { Button } from 'react-bootstrap'

const AlertBox = ({ show, onHide, onOk,Msg,...props }) => {
    const { t } = useTranslation()

    return (
        <div>
            <Modal
                {...props}
                size="lg"
                centered
                show={show}
                onHide={onHide}
                className="all-modal changeNumber"
            >
                <Modal.Body>{Msg ? t(`common:alert.${Msg}`) : t(`common:alert.deleteMsg`)}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={onOk}>
                        {t('common:alert.yes')}
                    </Button>
                    <Button variant="danger" onClick={onHide}>
                        {t('common:alert.no')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AlertBox
